import React from 'react';
import { FormattedMessage } from 'react-intl';

import Image from '@/components/route/blog/BlogPostImage/Image';
import Button, { ButtonSize, ButtonVariants } from '@/components/switchback/Button/Button';
import Heading, { THeadingLevels } from '@/components/switchback/Heading/Heading';
import Link from '@/components/switchback/Link/Link';
import { IBlogPost } from '@/services/types/blog/post.types';

import css from './BlogPostHero.module.css';

interface IPost {
  post: Pick<IBlogPost, 'images' | 'title' | 'categories' | 'slug'>;
  isTall?: boolean;
  hasButton?: boolean;
  level?: THeadingLevels;
}

const BlogPostHero: React.FC<IPost> = ({
  post: { images, title, categories, slug },
  level = 2,
  isTall = false,
  hasButton = true,
}) => {
  return (
    <>
      <div className="relative overflow-hidden">
        <div className={`relative overflow-hidden ${css.wrapper}`} data-height={isTall}>
          <div className={`absolute inset-0 w-full h-full`}>
            <Image
              images={images}
              title={title || 'Outdoorsy Blog Post Main Image'}
              className="object-cover w-full h-full"
              priority={true}
              quality={65}
            />
          </div>
        </div>
        <div
          className={`absolute bottom-0 left-0 content-end w-full p-3 pt-4 text-white grid lg:p-6 lg:pt-8 ${css.gradient}`}>
          <div className="w-full max-w-lg px-0 mx-auto lg:px-6">
            <p
              className="uppercase text autoType300"
              // @ts-expect-error fixable: unchecked index access
              dangerouslySetInnerHTML={{ __html: categories[0].name }}
            />
            {!!title && (
              <Heading level={level} className="highlight autoType900">
                <Link legacy href={`/blog/${slug}`}>
                  <a className="text-white" href={`/blog/${slug}`}>
                    <span dangerouslySetInnerHTML={{ __html: title }} />
                  </a>
                </Link>
              </Heading>
            )}
            {hasButton && (
              <div className="pt-4 w-36">
                <Button
                  variant={ButtonVariants.whiteOutlined}
                  size={ButtonSize.normal}
                  href={`/blog/${slug}`}>
                  <FormattedMessage defaultMessage="Read more" id="S++WdB" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPostHero;
